<template>
  <div>
  <form @submit.prevent="fetchLogs">
    <div class="row">
      <div class="col-md-6">
        <h5>Filters:</h5>
      </div>
      <div class="col-md-6">
        <button type="button" class="btn text-light btn-link bg-danger pull-right mr-1" @click="deleteLogs">
          Clear logs
        </button>
      </div>
      <div class="col-md-12">
        <div class="m-2 row">
          <div class="col-md-4">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" v-model="searchBy.email" class="custom-control-input" id="email"/>
              <label class="custom-control-label pt-4 mb-0" for="email">Email</label>
            </div>
            <input v-model="searchQuery.email" :required="searchBy.email" type="text" class="form-control mt-2" placeholder="Search by email" />
          </div>
          <div class="col-md-4">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" v-model="searchBy.operatingUser"  class="custom-control-input" id="operating-user"/>
              <label class="custom-control-label pt-4 mb-0" for="operating-user">Operating User</label>
            </div>
            <input v-model="searchQuery.operatingUser" :required="searchBy.operatingUser" type="text" class="form-control mt-2" placeholder="Search by operating user" />
          </div>
          <div class="col-md-4">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" v-model="searchBy.primaryPlan"  class="custom-control-input" id="primary-plan"/>
              <label class="custom-control-label pt-4 mb-0" for="primary-plan">Primary Domain</label>
            </div>
            <input v-model="searchQuery.primaryPlan" :required="searchBy.primaryPlan" type="text" class="form-control mt-2" placeholder="Search by primary domain" />
          </div>
        </div>
        <div class="row m-2">
          <div class="col-md-4">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" v-model="searchBy.dateRange"  class="custom-control-input" id="date-range"/>
              <label class="custom-control-label pt-4 mb-0" for="date-range">Date Range</label>
            </div>
            <date-range-picker
                class="w-100"
                ref="picker"
                :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY  HH:mm:ss' }"
                :showDropdowns="false"
                :timePicker="true"
                :timePicker24Hour="false"
                v-model="searchQuery.dateRange"
                :required="searchBy.dateRange"
            >
              <template v-slot:input="picker" style="min-width: 350px;">
                {{ (picker.startDate) ? formattedDate(picker.startDate) + ' - ' + formattedDate(picker.endDate) : 'Select Date range' }}
              </template>
            </date-range-picker>
          </div>
          <div class="col-md-4">
            <div class="custom-control custom-checkbox mt-4">
              <input type="checkbox" v-model="searchBy.onlyHooks"  class="custom-control-input" id="hook"/>
              <label class="custom-control-label pt-3 mb-0" for="hook">Hooks Logs</label>
            </div>
          </div>
          <div class="col-md-4">
            <button class="btn btn-primary mt-4" type="submit">
              Search
            </button>
            <button class="btn btn-danger mt-4" type="button" v-on:click="refreshLogs">
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="customer-list-info">
    <div class="loader" v-if="(logs.length === 0 && noLogs === false) || !asyncDone">
      <h3 style="position: relative;top: 125px;width: 500px;left: -80px;">{{asyncText}}</h3>
    </div>
    <p class="card-text text-center text-danger mb-3 font-weight-bold" v-if="noLogs && asyncDone">There are no
      logs in the database to show here.</p>
  </div>
  <div class="customer-table" v-if="logs.length > 0">
    <table id="datatable" class="table table-striped table-bordered">
      <thead>
      <tr>
        <th>Email</th>
        <th>Operating User (Is Admin)</th>
        <th>Primary Domain</th>
        <th style="width: 300px">Message</th>
        <th>Type</th>
        <th>Created</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="log in logs" :key="log.docID">
        <td>{{ log.email }}</td>
        <td>{{log.operatingUser}} ( {{ (log.isAdmin) ? 'Yes' : ' No' }} )</td>
        <td>{{ log.primaryPlan }}</td>
        <td style="width: 300px"><span :title="log.message" class="show-tip">{{ log.message }}</span></td>
        <td class="text-center">
          <span class="badge" :class="(log.level === 'error') ? 'badge-danger' : 'badge-' + log.level">{{log.level}}</span>
        </td>
        <td class="sort-date">{{ formattedDate(log.createdAt) }}</td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="row mt-2">
    <div class="col-md-12 text-center">
      <span class="pull-left mt-2"><b>Page Number: </b> {{ pageNumber + 1 }}</span>
      <button class="btn btn-link btn-sm btn-round" :disabled="pageNumber === 0" v-on:click="prevPage">
        Prev
      </button>
      <button class="btn btn-link btn-sm btn-round" :disabled="logs.length < pageSize" v-on:click="nextPage">
        Next
      </button>
    </div>
  </div>
  </div>
</template>
<script>
import {db} from "@/firebase/init";
import dateMixin from "../../../../mixins/dateMixin";
import swal from 'sweetalert2';
import moment from "moment";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  name: "OtherApplicationLogs",
  mixins: [dateMixin],
  components: { DateRangePicker },
  data() {
    return {
      filterByType: 'success',
      logs: [],
      noLogs: false,
      searchBy: {},
      searchData: [
        {
          for: 'level',
          value: 'success',
          name: 'Success'
        },{
          for: 'level',
          value: 'error',
          name: 'Error'
        },{
          for: 'level',
          value: 'info',
          name: 'Info'
        },{
          for: 'isAdmin',
          value: true,
          name: 'Yes'
        },{
          for: 'isAdmin',
          value: false,
          name: 'No'
        }],
      searchQuery: {
        dateRange: {
          startDate: null,
          endDate: null
        }
      },
      pageSize: 10,
      pageNumber: 0,
    };
  },
  computed: {
    asyncDone() {
      return this.$store.getters["async/state"];
    },
    asyncText() {
      return this.$store.getters["async/text"];
    },
    last () {
      return (this.logs.length > 0) ? this.logs[this.logs.length-1] : null;
    },
    first () {
      return (this.logs.length > 0) ? this.logs[0] : null;
    }
  },
  methods: {
    dateFormate (date) {
      return moment(date).format("MMM Do, YYYY")
    },
    getQuery () {
      let ref = db.collection('logs');
      if (this.searchBy.email && this.searchQuery.email) {
        console.log('in email')
        ref =  ref
            .where('email', "==", this.searchQuery.email.toLowerCase())
      }
      if (this.searchBy.operatingUser && this.searchQuery.operatingUser) {
        console.log('in operatingUser')
        ref =  ref
            .where('operatingUser', "==", this.searchQuery.operatingUser)
      }
      if (this.searchBy.primaryPlan && this.searchQuery.primaryPlan) {
        console.log('in primaryPlan')
        ref =  ref
            .where('primaryPlan', "==", this.searchQuery.primaryPlan.toLowerCase())
      }
      if (this.searchBy.dateRange && (this.searchQuery.dateRange.startDate && this.searchQuery.dateRange.endDate)) {
        console.log('in dateRange')
        ref =  ref
            .where('createdAt', ">=", this.searchQuery.dateRange.startDate.toISOString())
            .where('createdAt', "<=", this.searchQuery.dateRange.endDate.toISOString())
      }
      if (this.searchBy.onlyHooks) {
        console.log('in dateRange')
        ref =  ref
            .where('hook', "==", true)
      }
      console.log(ref)
      return ref
    },
    refreshLogs () {
      this.searchBy =  {}
      this.searchQuery =  {
        dateRange: {
          startDate: null,
          endDate: null
        }
      };
      this.noLogs = false;
      this.pageNumber = 0;
      this.fetchLogs();
    },
    async fetchLogs () {
      if (this.searchBy.dateRange && (!this.searchQuery.dateRange.startDate || !this.searchQuery.dateRange.endDate)) {
        return swal({
          title: "Warning!",
          text: 'Please select date range',
          type: "warning"
        })
      }
      console.log('fetching data')
      this.logs = [];
      this.noLogs = false;
      this.pageNumber = 0;
      let docs = [];
      try {
        const ref = await this.getQuery();
        docs = await ref
            .orderBy("createdAt", "desc")
            .limit(this.pageSize)
            .get()
        if (docs.empty === true) {
          this.noLogs = true;
        }
        docs.forEach(doc => {
          this.logs.push({
            docID: doc.id,
            ...doc.data()
          })
        });
      } catch (err) {
        console.error(err);
        // Show error message to the customer for 5 sec
        await this.$store.dispatch("alert/update", {
          type: "danger",
          message: err.name,
          show: true
        });

        setTimeout(() => {
          this.$store.dispatch("alert/showUpdate", {show: false});
        }, 5000);
      }

    },
    async nextPage() {
      console.log('I was called ')
      if (this.last) {
        this.pageNumber ++;
        this.noUser = false;
        await this.$store.dispatch("async/stateUpdate", {state: false});
        try {
          let docs = [];
          const ref = await this.getQuery();
          docs = await ref
              .orderBy("createdAt", "desc")
              .startAfter(this.last.createdAt)
              .limit(this.pageSize)
              .get();
          if (docs.empty === true) {
            this.noLogs = true;
          }
          this.logs = [];
          docs.forEach(doc => {
            this.logs.push({
              docID: doc.id,
              ...doc.data()
            })
          });
          await this.$store.dispatch("async/stateUpdate", {state: true});
        } catch (err) {
          console.error(err);
          // Show error message to the customer for 5 sec
          await this.$store.dispatch("alert/update", {
            type: "danger",
            message: err.name,
            show: true
          });
          await this.$store.dispatch("async/stateUpdate", {state: true});

          setTimeout(() => {
            this.$store.dispatch("alert/showUpdate", {show: false});
          }, 5000);
        }
      }
    },
    async prevPage(){
      if (this.first) {
        this.pageNumber --;
        this.noUser = false;
        await this.$store.dispatch("async/stateUpdate", {state: false});
        try {
          let docs = [];
          const ref = await this.getQuery();
          docs = await ref
              .orderBy("createdAt", "desc")
              .endBefore(this.first.createdAt)
              .limitToLast(this.pageSize)
              .get()
          if (docs.empty === true) {
            this.noLogs = true;
          }
          this.logs = [];
          docs.forEach(doc => {
            this.logs.push({
              docID: doc.id,
              ...doc.data()
            })
          });
          await this.$store.dispatch("async/stateUpdate", {state: true});
        } catch (err) {
          console.error(err);
          // Show error message to the customer for 5 sec
          await this.$store.dispatch("alert/update", {
            type: "danger",
            message: err.name,
            show: true
          });
          await this.$store.dispatch("async/stateUpdate", {state: true});

          setTimeout(() => {
            this.$store.dispatch("alert/showUpdate", {show: false});
          }, 5000);
        }
      }
    },
    deleteLogs() {
      swal({
        title: "Are you sure?",
        text: 'Please confirm that you want flush all logs of type: \'' + this.filterByType + '\'',
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      })
          .then( result => {
            // Check if the user has clicked YES
            if(result.value) {
              let collectionRef = db.collection("logs");
              collectionRef.where('level', '==', this.filterByType).get().then(async docs => {
                const batchSize = 500;
                let totalBatches = Math.ceil(docs.size / batchSize);
                let docReferences = [];
                docs.forEach(doc => {
                  docReferences.push(doc.ref);
                });
                for(let b = 0; b < totalBatches; b++) {
                  this.$store.dispatch("async/stateUpdate", {state: false, text: 'Deleting Batch: ' + (b + 1) + '/' + totalBatches});
                  let batch = db.batch();
                  let startIndex = b * batchSize;
                  let endIndex = (((batchSize + startIndex) < docs.size)) ? batchSize + startIndex : docs.size;
                  console.log(startIndex, endIndex);
                  for(let d = startIndex; d < endIndex; d++){
                    batch.delete(docReferences[d]);
                  }
                  await batch.commit();
                }
                await this.addLog({
                  message: 'User has remove all system logs',
                  level: "info"
                })
                this.$store.dispatch("async/stateUpdate", {state: true, text: ''});
                this.fetchLogs();
              })
            }
          });
    },
    filter(){
      this.fetchLogs();
    }
  },
  created() {
    this.fetchLogs();
  }
};
</script>

<style scoped>
table.table-bordered.dataTable th, table.table-bordered.dataTable td{
  word-break: break-all;
}
.custom-checkbox{
  display: flex;
  align-items: center;
  padding-bottom: 5px;
}
:deep(.reportrange-text){
  display: flex !important;
  align-items: center !important;
}
</style>